
  document.addEventListener("DOMContentLoaded",function(){
    let node = document.querySelector('.preload-transitions');
    if (node) {
      node.classList.remove('preload-transitions');
    }
  });
